import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface HttpUiError {
  status: number;
  message: string;
  url: string;
  method: string;
  modulo: string;
  codigo?: string;
  traceId?: string;
  timestamp: string;
}

@Injectable({ providedIn: 'root' })
export class HttpStateService {
  private pendingCount = 0;

  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private readonly lastErrorSubject = new BehaviorSubject<HttpUiError | null>(null);

  readonly loading$ = this.loadingSubject.asObservable();
  readonly lastError$ = this.lastErrorSubject.asObservable();

  startRequest(): void {
    this.pendingCount += 1;
    if (this.pendingCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  finishRequest(): void {
    this.pendingCount = Math.max(0, this.pendingCount - 1);
    if (this.pendingCount === 0) {
      this.loadingSubject.next(false);
    }
  }

  setError(error: HttpUiError): void {
    this.lastErrorSubject.next(error);
  }

  clearError(): void {
    this.lastErrorSubject.next(null);
  }
}
